import { List, ListItem, Drawer, DrawerContent, DrawerDescription, DrawerTitle, ListContent, DrawerBody, DrawerHeader } from "@fr8/frui";
import { Check } from 'lucide-react'
const countryCodeList = [
    { country_id: 1, country_name: "United Arab Emirates", country_code: "971" },
    { country_id: 2, country_name: "Saudi Arabia", country_code: "966" },
    { country_id: 3, country_name: "Oman", country_code: "968" },
    { country_id: 4, country_name: "Qatar", country_code: "974" },
    { country_id: 6, country_name: "Bahrain", country_code: "973" },
    { country_id: 5, country_name: "Kuwait", country_code: "965" },
    { country_id: 7, country_name: "Gaza", country_code: "970" },
    { country_id: 8, country_name: "Jordan", country_code: "962" },
]

type countryType = typeof countryCodeList[1]

interface CountryCodeSelectProps {
    selectedValue: string | null;
    onSelectCountryCode: (value: countryType) => void;
    onClose: () => void;
    open: boolean
    countryObj?: countryType
}

const CountryCodeSelect = (props: CountryCodeSelectProps) => {
    const { onSelectCountryCode, open, selectedValue, onClose, countryObj } = props

    const onCountryCodeSelect = (country: countryType) => {
        onSelectCountryCode(country)
        onClose()
    }

    const onDrawerDismiss = () => {
        onClose()
    }

    const countryCodeListExtended = [...countryCodeList, countryObj || null].filter((item): item is countryType => item !== null)
    return (
        <Drawer
            open={open}
            dismissible={true}
            onOpenChange={(open: boolean) => (open ? undefined : onDrawerDismiss())}
        >
            <DrawerContent className="pb-8">
                <DrawerHeader>
                    <DrawerTitle className="text-lg">Select Country Code</DrawerTitle>
                    <DrawerDescription className='sr-only'>{""}</DrawerDescription>
                </DrawerHeader>
                <DrawerBody>
                    <List>
                        {countryCodeListExtended.map(
                            (country) =>
                                <ListItem clickable onClick={() => onCountryCodeSelect(country)} key={country.country_id.toString()}>
                                    <ListContent>
                                        <span className="font-semibold text-lg">+{country.country_code} &nbsp;&nbsp;</span>
                                        <span>{country.country_name}</span>
                                    </ListContent>
                                    {selectedValue === country.country_code ? <Check className="text-secondary" /> : null}
                                </ListItem>
                        )}
                    </List>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

export default CountryCodeSelect
